export default __webpack_public_path__ + "static/2-fa932f617851c3e923792c36d0d50523.jpg";